<template>
  <div class="admin-profile">
    <CRow>
      <CCol>
        <div
          class="admin-profile__info"
        >
          <div class="admin-profile__info-avatar">
            <VUserIcon :src="user.avatar" class="" />
          </div>
          <div class="admin-profile__info-user-description">
            <div class="admin-profile__info-user-description-main">
              <div class="admin-profile__info-username">
                {{user.username}}
              </div>
              <div class="admin-profile__info-role">
                {{userRole}}
              </div>
            </div>
            <div class="admin-profile__info-user-description-sub">
              <div class="admin-profile__info-email">
                {{user.email}}
              </div>
              <div class="admin-profile__info-phone">
                {{user.phoneNumber}}
              </div>
              <div class="admin-profile__info-bio">
                {{user.bio}}
              </div>
            </div>
          </div>
          <div class="admin-profile__info-buttons">
            <CButton
              @click="onEdit"
            >
              Edit profile
            </CButton>
            <CButton
              @click="onChangePassword"
            >
              Change password
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CRow>
      <CCol>
        <h4 class="admin-profile__history-title">Approved/Declined cars</h4>
      </CCol>
    </CRow>
    <TheAdminHistory />
  </div>
</template>

<script>
import TheAdminHistory from "./TheAdminHistory"
import { getUserRole } from "@/utils/validation/user";
import {
  createAuthStoreMixin,
  authStore,
} from '@/mixins/authStoreMixin'
import ModalType from '@/utils/dictionaries/modalType';

export default {
  name: 'TheAdminProfile',

  components: {
    TheAdminHistory
  },

  mixins: [createAuthStoreMixin()],

  data() {
    return {
      hiddenFields: {
        username: true,
        email: true,
        role: true,
        password: true,
      }
    }
  },

  computed: {
    user() {
      return this[authStore.getterTypes.GETTER_USER]
    },
    userRole() {
      return getUserRole(this.user)
    }
  },

  methods: {
    onEdit() {
      this.$modals.open(ModalType.CreateUserModal, { 
        ...this.user,
        isManager: true, 
        hiddenFields: this.hiddenFields 
      })
    },
    onChangePassword() {
      this.$modals.open(ModalType.ChangePasswordModal)
    }
  }
  
}

</script>